import React from "react";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import CircularProgress from "@mui/material/CircularProgress";

import { fullWidthDialog } from "src/constants/dialog";

export default function LoadingDialog({ onClose } = {}) {
  return (
    <Dialog open maxWidth="sm" fullWidth onClose={onClose} sx={fullWidthDialog}>
      <Box p={3} display="flex" minHeight={400} alignItems="center" justifyContent="center">
        <CircularProgress color="primary" />
      </Box>
    </Dialog>
  );
}
